export function formatJsonToText(data) {
    let result = "";
  
    function processObject(obj, indent = "") {
      for (let key in obj) {
        if (typeof obj[key] === "object" && !Array.isArray(obj[key])) {
          // Если значение является объектом, добавляем заголовок и рекурсивно обрабатываем
          result += `${indent}${key}:\n`;
          processObject(obj[key], indent + "  ");
        } else {
          // Если значение не является объектом, добавляем ключ и значение
          result += `${indent}${key}: ${obj[key]}\n`;
        }
      }
    }
  
    processObject(data);
    return result;
  }